export const translations = {
  en: {
    placeHolderAll: 'All',
    labelAnd: 'AND',
    labelOr: 'OR',
    labelIntervention: 'Interventions',
    labelOutcome: 'Outcomes',
    downloadPNG: 'Download PNG image',
    downloadJPEG: 'Download JPEG image',
    downloadSVG: 'Download SVG vector image',
    downloadPDF: 'Download PDF image',
    downloadCSV: 'Download CSV file',
    downloadRIS: 'Download RIS file',
    exportCSV: 'Export CSV file',
    exportRIS: 'Export RIS file',
    printChart: 'Print Chart',
    exportDesc: 'Click here to export the matrix. The export file will reflect the filters you have applied. Available formats: png, jpeg, pdf, svg, csv, ris.',
    labelStudies: 'Total unique studies',
    labelUpdateChart: 'Update Chart',
    labelFilterCondition: 'Filter condition (between filters):',
    sideFilterDesc: "Click here to hide interventions and outcomes not of interest to you. Simply untick all categories you do not wish to display in the matrix and click 'Apply'.",
    toolTipOrFilter: "Select OR if you are interested in studies that consider <em>any</em> of the selected items.",
    toolTipAndFilter: "Select AND if you are interested in studies that consider <em>all</em> of the selected items.",
    labelAllStudies: 'All studies',
  },
  es: {
    placeHolderAll: 'Todos',
    labelAnd: 'Y',
    labelOr: 'O',
    labelIntervention: 'Intervenciones',
    labelOutcome: 'Resultados',
    downloadPNG: 'Descargar imagen PNG',
    downloadJPEG: 'Descargar imagen JPEG',
    downloadSVG: 'Descargar imagen SVG vectorial',
    downloadPDF: 'Descargar imagen PDF',
    downloadCSV: 'Descargar archivo CSV',
    downloadRIS: 'Descargar archivo RIS',
    exportCSV: 'Exportar archivo CSV',
    exportRIS: 'Exportar archivo RIS',
    printChart: 'Imprimir Gráfico',
    exportDesc: 'Haga clic aquí para exportar la matriz. El archivo de exportación reflejará los filtros que ha aplicado. Formatos disponibles: png, jpeg, pdf, svg, csv, ris.',
    labelStudies: 'Total de estudios únicos',
    labelUpdateChart: 'Actualizar Gráfico',
    labelFilterCondition: 'Condición de filtro (entre filtros):',
    sideFilterDesc: "Haga clic aquí para ocultar las intervenciones y resultados que no le interesan. Simplemente desmarque todas las categorías que no desea mostrar en la matriz y haga clic en 'Aplicar'.",
    toolTipOrFilter: "Seleccione O si le interesan los estudios que consideran <em>cualquiera</em> de los elementos seleccionados.",
    toolTipAndFilter: "Seleccione Y si le interesan los estudios que consideran <em>todos</em> los elementos seleccionados.",
    labelAllStudies: 'Todos los estudios',
  },
};